import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

class PageNav extends Component {
    getPrevPage() {
        //const pageNum = parseInt(this.props.routerMatch.params.pageNum) || 1;
        return '/';
    }

    getSlug() {
        if (('undefined' !== typeof this.props.routerMatch.params.slug || 'undefined' !== typeof this.props.routerMatch.params.term) && 'undefined' !== typeof this.props.routerMatch.url) {
            let tax = 'category';
            let urlParts = this.props.routerMatch.url.split('/');
            if (urlParts.length) {
                urlParts = urlParts.filter(part => {
                    return "" !== part && this.props.routerMatch.params.slug !== part
                });
                if (urlParts.length) {
                    tax = urlParts[0];
                }
            }
            let slug = this.props.routerMatch.params.slug || this.props.routerMatch.params.term;
            return `/${tax}/${slug}`;
        } else {
            return "";
        }
    }

    getNextPage() {
        //const pageNum = parseInt(this.props.routerMatch.params.pageNum) || 1;
        return '/';
    }

    render() {
        if (this.props.shouldRender) {
            return (
                <div className="page-nav-wrapper">
					<div className="row">
						<div className="col-12">
							<div className="page-nav-btns">
								{(true) ?
									<Link to={this.getPrevPage()} className="btn btn-default btn-page-prev">Previous</Link> : ''}
									
									<Link to={this.getNextPage()} className="btn btn-default btn-page-next">Next</Link>
							</div>
						</div>
					</div>
				</div>            );
        } else {
            return <span/>;
        }
    }
}

function mapStateToProps({routerMatch}) {
    return {routerMatch};
}

export default connect(mapStateToProps)(PageNav);


// WEBPACK FOOTER //
// ./src/containers/parts/page-nav.js